import { FormattedMessage } from 'react-intl'
import MobileFilterToggle from '../search/MobileFilterToggle'
import './sorting-mobile.sass'

export default function MobileFilterToggleDr({ sorting, updateParams, updateOrdering, isActiveFilter, filtersCount }) {
  return (<div className='results-actions'>
    <a className='results-action' id='js-action-map' onClick={() => updateParams({ view: 'map' })}>
      <i className='font-icons map-icon' />
      <FormattedMessage id='map' defaultMessage='Map' />
    </a>
    <a className='results-action'>
      <span className='sorting-mobile-toggler'>
        <i className='font-icons icon-sorting' />
        <FormattedMessage id='sort' defaultMessage='Sort' />
      </span>
      <ul className='sorting-mobile'>
        {
          sorting.map((sort, index) => {
            return (<li key={index} onClick={() => updateOrdering(sort)} className={isActiveFilter(sort)}>
              { sort.title }
            </li>)
          })
        }
      </ul>
    </a>
    <MobileFilterToggle filtersCount={filtersCount} />
  </div>)
}
